import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExceptionHelper, UserStorage } from './../../../../helper';

import { Report, ReportNormalUserRole } from '../report';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';
import { Roles } from '../../../../model';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html'
})
export class ReportSummaryComponent implements OnInit, AfterViewInit {

  reports: any[];
  dataTable: any;

  constructor(
    private exception: ExceptionHelper,
    private user: UserStorage,
    private translateService: TranslateService,
    private chRef: ChangeDetectorRef) {
    translateService.setDefaultLang('en-us');
  }

  ngAfterViewInit() {
    this.getSummary();
  }

  ngOnInit() {

  }

  public isAdminRole() {
    return this.user.getLocalUserRole() === Roles.Admin;
  }

  getSummary() {

      if ($.fn.dataTable.isDataTable('#reportsDataTables')) { $('#reportsDataTables').DataTable().destroy(); }
      // console.log(this.user.isAdmin());
        if (this.user.isAdmin()) {
          this.reports = Report;
        } else{
          this.reports = ReportNormalUserRole;
        }

          this.chRef.detectChanges();

          const table: any = $('#reportsDataTables');
          this.dataTable = table.DataTable({
            "paging":   false,
            "ordering": false,
            "info":     false,
            "searching":     false
          });

  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/report/report-summary/report-summary.component.ts